export const getUrlParam = (param: string): string => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search.slice(1));

  return params.get(param);
};
